var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 17.5C13.75 16.8097 14.3097 16.25 15 16.25H35C35.6904 16.25 36.25 16.8097 36.25 17.5C36.25 18.1904 35.6904 18.75 35 18.75H15C14.3097 18.75 13.75 18.1904 13.75 17.5ZM13.75 25C13.75 24.3096 14.3097 23.75 15 23.75H27.5C28.1904 23.75 28.75 24.3096 28.75 25C28.75 25.6904 28.1904 26.25 27.5 26.25H15C14.3097 26.25 13.75 25.6904 13.75 25ZM13.75 32.5C13.75 31.8096 14.3097 31.25 15 31.25H21.25C21.9403 31.25 22.5 31.8096 22.5 32.5C22.5 33.1904 21.9403 33.75 21.25 33.75H15C14.3097 33.75 13.75 33.1904 13.75 32.5Z",
    fill: "#464255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/CollapseIcon.18d46f306c271f81679306fecf00c308.svg";
export { ForwardRef as ReactComponent };